import $ from 'jquery';
import isotope from 'isotope-layout';
import { getWidth } from "../utils/window";

export default function masonryEnhancement(context=document.body) {
	// const $context = $(context);

	const masonry = $('[sw-masonry]');

   // $(function(){
   //    if(masonry.length > 0) {
   //       masonry.each(function(){
   //          const iso = new isotope(this, {
   //             itemSelector: '.cell',
   //             percentPosition: true,
   //             masonry: {
   //               // use outer width of grid-sizer for columnWidth
   //               columnWidth: '.cell'
   //             }
   //           });
   //       });
   //    }
   // });

   $(window).on('load', function() {
      if(masonry.length > 0 && getWidth() > 768) {
         masonry.each(function(){
            const iso = new isotope(this, {
               itemSelector: '.cell',
               percentPosition: true,
               masonry: {
                 // use outer width of grid-sizer for columnWidth
                 columnWidth: '.cell'
               }
             });

            $(this).addClass('is-mason-ready');
         });
      }
   });
}



// WEBPACK FOOTER //
// ./source/scripts/enhancements/masonry.js